<template>
  <div>
    <!-- <table class="d-none d-md-table">
      <thead>
        <th></th>
        <th class="vertical-align-bottom">Count</th>
        <th
          v-for="option in options"
          :key="option.value"
          class="text-right"
          :style="`width: ${100 / (options.length + 2)}%`"
        >
          {{ option.text }}
        </th>
      </thead>
      <tr v-for="(dataSet, index) in questionDataSets" :key="index">
        <td class="text-capitalize">{{ index }}</td>
        <td class="text-right">
          {{ dataSet.total | number }}
        </td>
        <td class="text-right" v-for="option in options" :key="option.value">
          {{ getOptionPercentage(dataSet, option) | percentage }}
        </td>
      </tr>
      <tfoot>
        <td v-for="i in options.length + 2" :key="i"></td>
      </tfoot>
    </table> -->
    <table>
      <thead>
        <th></th>
        <template v-for="(dataSet, index) in dataSets">
          <th
            class="vertical-align-bottom text-right text-capitalize"
            :key="index"
            v-if="dataSet"
          >
             {{ index }}<span v-if="index === 'district'">/Charter</span>
          </th>
        </template>
      </thead>
      <tr v-for="option in tableOptions" :key="option.value">
        <td class="w-100">{{ option.text }}</td>
        <template v-for="(dataSet, index) in dataSets">
          <td class="text-right text-no-wrap" :key="index" v-if="dataSet">
            <template v-if="questionDataSets[index]">
              <div>
                {{
                  getOptionPercentage(questionDataSets[index], option)
                    | percentage
                }}
              </div>
            </template>
            <template v-else>
              {{ questionDataSets[index] == null ? "--" : "--" }}
            </template>
          </td>
        </template>
      </tr>
      <tr v-if="questionType !== 'checklist'">
        <td
          class="grey darken-2 py-0"
          v-for="i in getKeyCount(dataSets, false) + 1"
          :key="i"
        ></td>
      </tr>
      <tr v-if="questionType !== 'checklist'" class="overflow-hidden">
        <td
          class="grey darken-2 py-0"
          v-for="i in getKeyCount(dataSets, false) + 1"
          :key="i"
        ></td>
      </tr>
      <tr v-if="questionType !== 'checklist'">
        <td class="font-weight-bold">Counts</td>
        <template v-for="(dataSet, index) in dataSets">
          <td
            class="text-right pl-12 font-weight-bold text-no-wrap"
            :key="index"
            v-if="dataSet"
          >
            <template
              v-if="
                !questionDataSets[index] ||
                  questionDataSets[index].total == null ||
                  questionDataSets[index].total < 5
              "
            >
              --
            </template>
            <template v-else>
              {{ questionDataSets[index].total | number }}
            </template>
          </td>
        </template>
      </tr>
    </table>
  </div>
</template>

<style scoped lang="scss">
$blueFill: rgba(101, 146, 230, 0.15);
$greyFill: rgba(0, 0, 0, 0.05);

table {
  border-collapse: collapse; /* Remove cell spacing */

  thead {
    th {
      vertical-align: bottom;
      text-align: center;
      padding-top: 0.5rem;
      border-radius: 0.5rem 0.5rem 0 0;
      padding: 0.5rem 1rem 0.25rem 1rem;

      &:nth-child(even) {
        background: $greyFill;
      }
    }
  }

  th,
  td {
    padding: 0.25rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    text-align: left;
  }

  tr,
  tfoot {
    &:nth-child(odd) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
    &:nth-child(even) {
      th,
      td {
        &:nth-child(even) {
          background: $greyFill;
        }
      }
    }
  }

  tr {
    &:hover {
      background: rgba(0, 0, 0, 0.15) !important;

      td {
        border-color: rgba(0, 0, 0, 0.25);
      }
    }

    &:nth-child(even) {
      background: $blueFill;
    }
  }

  tfoot {
    td {
      border-radius: 0 0 0.5rem 0.5rem;
      padding: 0.5rem;
    }
  }
}
</style>

<script>
import {
  getQuestionDatasets,
  getOptionPercentage,
  getKeyCount,
} from "./Results.ItemAnalysis.Generators";

import { questionTypes } from "../../../constants/Survey";

import numeral from "numeral";

const selectedOptions = [
  {
    text: "True",
    value: "true",
    mappingValue: "true",
  },
  {
    text: "False",
    value: "false",
    mappingValue: "false",
  },
];

export default {
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    },
  },
  data: () => ({
    questionTypes,
    selectedOptions,
  }),
  props: {
    question: Object,
    questionKey: String,
    questionType: String,
    dataSets: Object,
    options: Array,
  },
  computed: {
    questionDataSets() {
      return getQuestionDatasets(
        this.question,
        this.questionKey,
        this.tableOptions,
        this.dataSets
      );
      
    },
    tableOptions() {
      // if (this.question?.type === questionTypes.checklist) {
        
      //   if (this.selectedOptions.length === 0) {
      //     this.question.children.forEach((child) => {
      //       this.selectedOptions.push({
      //         text: child.text,
      //         value: child.key,
      //         mappingValue: child.mappingKey,
      //       });
      //     });
      //   }


      //   return selectedOptions;
      // }

      return this.options;
    },
  },
  methods: {
    getOptionPercentage,
    getKeyCount,
  },
};
</script>
